const Book = () => import('views/book/Book')
const BookIndex = () => import('views/book/BookIndex')
const BookInfo = () => import('views/book/BookInfo')
const BookReader = () => import('views/book/BookReader')

export default {
  path: '/book',
  name: 'Book',
  component: Book,
  meta: { needAuth: false },
  children: [
    {
      path: '',
      name: 'BookIndex',
      component: BookIndex,
      meta: { needAuth: false }
    },
    {
      path: '/book/info/:id',
      name: 'BookInfo',
      component: BookInfo,
      meta: { title: 'BookInfo', needAuth: false }
    },
    {
      path: '/book/reader/:id',
      name: 'BookReader',
      component: BookReader,
      meta: { title: 'BookReader', needAuth: false }
    }
  ]
}
